import React, { Component, refs } from "react";
import ReactDom, { render } from "react-dom";
import AvatarEditor from "react-avatar-editor";
import Avatar from "material-ui/Avatar";
import RaisedButton from "material-ui/RaisedButton";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import Slider from "material-ui/Slider";
import { Row, Col, Container } from 'reactstrap';
import AvatarDefaultImg from '../../images/avatarDefault.png';

class Avatars extends Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.setEditorRef = this.setEditorRef.bind(this);
    this.handleZoomSlider = this.handleZoomSlider.bind(this);
    this.state = {
      cropperOpen: false,
      img: null,
      zoom: 2,
      croppedImg: AvatarDefaultImg
    };
  }

  handleZoomSlider(event, value) {
    let state = this.state;
    state.zoom = value;
    this.setState(state);
  }

  handleFileChange(e) {
    let url = window.URL.createObjectURL(e.target.files[0]);
    ReactDom.findDOMNode(this.refs.in).value = "";
    let state = this.state;
    state.img = url;
    state.cropperOpen = true;
    this.setState(state);
  }

  handleSave(e) {
    if (this.editor) {
      const canvasScaled = this.editor.getImageScaledToCanvas();
      const croppedImg = canvasScaled.toDataURL();

      let state = this.state;
      state.img = null;
      state.cropperOpen = false;
      state.croppedImg = croppedImg;
      this.setState(state);
    }
  }

  handleRemove(e) {    
    let state = this.state;
    const croppedImg = AvatarDefaultImg;
    state.cropperOpen = false;
    state.croppedImg = croppedImg;
    this.setState(state);
  }

  handleCancel() {
    let state = this.state;
    state.cropperOpen = false;
    this.setState(state);
  }
  setEditorRef(editor) {
    this.editor = editor;
  }

  render() {
    return (
      <MuiThemeProvider>
        <div className="avatar">
          <Container fluid>
            <Container>
            {!this.state.cropperOpen && <Row>
              <Col>
                <Row>
                  <Col xl={12} md={12} xs={12} className="mt-3 mb-3 mr-auto ml-auto" style={{textAlign: 'center'}}>
                    <Avatar src={this.state.croppedImg} size={160} />
                  </Col>
                </Row>                
                <Row>
                  <Col xl={12} md={12} xs={12} className="mt-2 mb-2 mr-auto ml-auto">
                    <h3>Сhange your avatar</h3>
                    <p>Upload your avatar</p>
                  </Col>
                </Row>
                <Row>
                  <Col className="change-remove">
                    <Row>
                      <Col xl={6} md={6} xs={6} className="mt-2 mb-2 mr-auto ml-auto">
                        <RaisedButton id='change' containerElement="label" style={{borderRadius: "10px", boxShadow: '0'}}>
                          Change
                          <input ref="in" type="file"  accept="image/*" style={{display: 'none', background: 'transparent'}} onChange={this.handleFileChange} />
                        </RaisedButton>
                      </Col>
                      <Col xl={6} md={6} xs={6} className="mt-2 mb-2 mr-auto ml-auto">
                        
                        <RaisedButton 
                        id='remove' 
                        label=''
                        containerElement="label"
                        onClick={this.handleRemove} style={{borderRadius: "10px", boxShadow: '0'}}>
                          Remove                        
                        </RaisedButton>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>}
            {this.state.cropperOpen && (
              <Row className="cropper-wrapper">
                <Row>
                  <Col xl={12} md={12} xs={12}>
                    <h3>Edit</h3>
                  </Col>
                </Row>
                <Row>
                  <Col xl={12} md={12} xs={12} className="mb-2">
                    <p>Crop your photo</p>
                  </Col>
                </Row>
                <Row>
                  <Col xl={12} md={12} xs={12} className="image-edit">
                      <AvatarEditor ref={this.setEditorRef} image={this.state.img} scale={this.state.zoom}
                      width={250}
                      height={250}
                      border={15}
                      borderRadius={150}
                      color={[56, 56, 56, 0.5]} // RGBA
                      />
                  </Col>
                </Row>
                <Row className="av-center">
                  <Slider
                    id='slider'
                    min={1}
                    max={10}
                    step={0.1}
                    value={this.state.zoom}
                    onChange={this.handleZoomSlider}
                    style={{ width: 160 }}
                  />
                </Row>              
                <Row>
                  <Col className="save-cancel">
                    <Row>
                      <Col xl={6} md={6} xs={6} className="mr-auto ml-auto">
                        <RaisedButton 
                        id='save' 
                        label=''
                        labelPosition="before"
                        containerElement="label"
                        onClick={this.handleSave} style={{borderRadius: "10px", boxShadow: '0'}}>
                          &nbsp; Save &nbsp;                          
                        </RaisedButton>
                      </Col>
                      <Col xl={6} md={6} xs={6} className="mr-auto ml-auto">
                        <RaisedButton 
                        id='cancel'
                        label=''
                        labelPosition="before"
                        containerElement="label"
                        onClick={this.handleCancel} style={{borderRadius: "10px", boxShadow: '0'}}>
                          Cancel                          
                        </RaisedButton>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Row>
            )}
            <Row className="image-details">
              <Col>                
                <ul>
                  <li>Dimensions: 1:1 ratio</li>
                  <li>Formats: PNG, JPEG3</li>
                  <li>Min size 110:110</li>
                  <li>Max 512:512px</li>
                  <li>Maximum file size: 1024KB</li>
                </ul>
              </Col>
            </Row>
            </Container>
          </Container>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default Avatars



// WEBPACK FOOTER //
// ./src/containers/avatar/Avatars.js